import * as React from 'react';
import ReactTooltip from 'react-tooltip';
import { IBIconButtonProps } from './IconButton.types';
import { SvgImage } from '../SvgImage';
import { NoneButton } from '../AttachmentTag/AttachmentTag';

const IconButton: React.FC<IBIconButtonProps> = (props: IBIconButtonProps) => {
  const {
    className,
    icon,
    type,
    onClick,
    id,
    tooltipId,
    tooltipText,
    testId
  } = props;
  ReactTooltip.rebuild();

  return (
    <NoneButton
      type={type}
      id={id ?? ''}
      className={`${className}`}
      onClick={onClick}
      data-for={tooltipId}
      data-tip={tooltipText}
      title={tooltipText}
      data-testid={testId || 'icon-button'}
    >
      <SvgImage inAssetsPath={icon} />
    </NoneButton>
  );
};

export default IconButton;
